import { createContext } from "react";
import socketio from "socket.io-client";
import { webSockLink } from "../utility/Constants";

export const socket = socketio(webSockLink);
const SocketContext = createContext();

// export const SocketProvider = SocketContext.Provider;
// export const SocketConsumer = SocketContext.Consumer;
export default SocketContext;
